export default "__VITE_PUBLIC_ASSET__acc8e2df__"